import { render, staticRenderFns } from "./ProfileChangePassword.vue?vue&type=template&id=e12c742c&"
import script from "./ProfileChangePassword.vue?vue&type=script&lang=js&"
export * from "./ProfileChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports